import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import ChatBoxModal from "../../../../common/chatBoxModal";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import greyStartUp from "../../../../../assets/svg/greyStartUp.svg";
import Pagination from "react-js-pagination";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { Button as MaterialButton } from "@material-ui/core";
import { getStartupList } from "../dependencies/action";
import axios from "axios";
import { VIEW_STARTUPLST_COUNTER_OPTIONS } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import Select from "react-select";
import mentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import Button from "../../AdminDashboard/Button";
import { Country, State, City } from "country-state-city";
import "./style.scss";

import {
  getPredefineOptionsList,
  getNamesList,
  destructNamesList,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { PRODUCTION_MOVE_HIDDEN } from "../../../../common/constants/actionConstants";
const AllStartUpList = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getStartupList,
    startUpList,
    startUpListPagineate,
    getPredefineOptionsList,
    getPredefineOptions,
    getNamesList,
    getNamesListData,
    getStartuplistCountersList,
    getStepperTooltipData,
    getStepperData,
    destructNamesList,
  } = props;
  const history = useHistory();
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("SUBMITTED");
  const [activePage, setActivePage] = useState(1);
  const [tableList, setTableList] = useState();
  const currentRoute = window.location.href;
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const [formData, setFormData] = useState(defaultFormData);

  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterName, setFilterName] = useState("");
  const newCountryArray = [];
  const newStateArray = [];
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [filterNameValue, setFilterNameValue] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [counterData, setCounterData] = useState();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const indDefaultObject2 = {
    value: "select",
    label: "Select State",
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    html.style.overflow = "auto";

    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    localStorage.setItem("allStartupList", "allStartupList");
    setTimeout(() => {
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
    }, 1000);
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // props.openLoader();
    // axios({
    //   url: VIEW_STARTUPLST_COUNTER_OPTIONS,
    //   method: "POST",
    //   data: {
    //     requestedBy: value?.id,
    //   },
    // })
    api
      .POST(VIEW_STARTUPLST_COUNTER_OPTIONS, {
        requestedBy: value?.id,
      })
      .then((res) => {
        setCounterData(res?.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, []);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);

  useEffect(() => {
    if (getNamesListData !== undefined && getNamesList !== null)
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select StartUp",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (getNamesListData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  const getStartUpListData = (status) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: "",
      id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      searchField: filterNameValue === "Select" ? "" : filterNameValue,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: status
        ? status === "Total"
          ? "SUBMITTED"
          : status
        : selectedStatus?selectedStatus:"SUBMITTED",
    };
    getStartupList(params);
  };
  const getStartUpListDataNameSearch = (name) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: "",
      id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      searchField: name === "Select" ? "" : name,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: selectedStatus,
    };
    getStartupList(params);
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: "",
      id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      status: selectedStatus,
      searchField:
        formData?.name?.value == "select" ? "" : formData?.name?.value,
      searchKey: null,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getStartupList(params);
  };
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
    newStateArray.unshift(indDefaultObject2);
    getStartUpListData("SUBMITTED");
  }, []);
  useEffect(() => {
    setTableList(startUpList);
  }, [startUpList]);

  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const ViewApplication = (item) => {
    let reRoute = window.open(`/view-StartupApplication/${item}`, "_blank");
    reRoute.id = item;
    reRoute.fromModule = "startUpApplications";
  };
  const handlePreviousPage = () => {
    if (props?.history?.location?.state?.fromModule === "startUpApplications") {
      localStorage.setItem("startUpApplications", "startUpApplications");
      localStorage.removeItem("allStartupList");
      window.location.reload();
    } else if (history?.location?.state?.fromModule === "activitySummary") {
      localStorage.setItem("activitySummary", "activitySummary");
      localStorage.removeItem("allStartupList");
      window.location.reload();
    } else {
      localStorage.setItem("mentorDashboardHome", "mentorDashboardHome");
      localStorage.removeItem("allStartupList");
      window.location.reload();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  useEffect(() => {
    return () => {
      destructNamesList();
    };
  }, []);
  return (
    <>
      <div className="mentorlistmaindiv startuplistmaindivdata">
        <div
          className="dashboard-main2 admndashallstrtuplistmaindiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={handlePreviousPage}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                {history?.location?.state?.fromModule === "activitySummary"
                  ? "Click to Go Activity Summary"
                  : props?.history?.location?.state?.fromModule ===
                    "startUpApplications"
                  ? "Click to Go Startup Applications "
                  : "Click to Go My Dashboard"}
              </span>
            </div>
          </div>
          <div className="iconWith-heading admndashallstrtuplistappwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ADMIN DASHBOARD: ALL STARTUP LIST
              </h3>
            </div>
            {!PRODUCTION_MOVE_HIDDEN && <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>}
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew startuplist-01 mobileviewmentorbelow">
            <div
              className="mentorImageParent"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={greyStartUp} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3 startup-button01">
              <p className="text-white">STARTUPS</p>
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("SUBMITTED");
                  getStartUpListData("Total");
                  setActivePage(1);
                }}
                style={{ color: activeText ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                TOTAL STARTUPS : {counterData ? counterData.total : "00"}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Total Startups
              </span>
              {activeText ? <img src={LineWithDot} /> : ""}
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("ACTIVE");
                  getStartUpListData("ACTIVE");
                  setActivePage(1);
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                ACTIVE STARTUPS : {counterData ? counterData.active : "00"}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Active Startups
              </span>
              {activeText2 ? <img src={LineWithDot} /> : ""}
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  setSelectedStatus("INACTIVE");
                  getStartUpListData("INACTIVE");
                  setActivePage(1);
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                INACTIVE STARTUPS : {counterData ? counterData.inactive : "00"}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Inactive Startups
              </span>
              {activeText3 ? <img src={LineWithDot} /> : ""}
            </div>
          </div>

          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getStartUpListDataNameSearch(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search StartUp"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Startup
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip ">
                    <Button
                      onClick={() => getStartUpListData(selectedStatus)}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput srchsrtupsstrtuplistadmindash"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.name);
                        setFilterNameValue(e.value);
                        getStartUpListDataNameSearch(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search StartUp"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput srchsrtupsstrtuplistadmindash"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div> */}

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput srchsrtupsstrtuplistadmindash"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button className="green-btn filter-btn" text="GO" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="totalTableCount">
            Total Startups Found: {startUpListPagineate?.totalElements} &lt;
            {startUpListPagineate?.currentPage} of{" "}
            {startUpListPagineate?.numPages} &gt;{" "}
          </div>
          {startUpList !== undefined && startUpList?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered allstrtuplisttablediv">
                  <thead>
                    <tr>
                      <th className="tableJustify fixColumbnWidth4">NO.</th>
                      <th className="fixColumbnWidth" colspan="2">
                        STARTUP
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}>DPIIT ID</th>
                      <th>CITY</th>
                      <th>MENTORSHIPS</th>
                      <th>CONTACT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {startUpList.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          item.id === indexCounter ? "purpleBackground" : ""
                        }
                      >
                        {startUpListPagineate.currentPage === 1 ? (
                          <td style={{ verticalAlign: "middle" }}>
                            {index + 1}
                          </td>
                        ) : (
                          <td style={{ verticalAlign: "middle" }}>
                            {index +
                              1 +
                              10 * (startUpListPagineate.currentPage - 1)}
                          </td>
                        )}
                        <td
                          style={
                            {
                              // display: "flex",
                              // justifyContent: "center",
                            }
                          }
                          className="strtupimgtddiv"
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              src={item.logo === null ? hashImage : item.logo}
                              onClick={() => {
                                setIndexCounter(item.id);
                                redirectProfile(item.dippNumber);
                              }}
                              className="sidebar-dashboard-icon2"
                              style={{
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                                objectFit: "contain",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "46px",
                                top: "88px",
                                width: "150px",
                              }}
                            >
                              View Startup Profile
                            </span>
                            <div
                              className="srtupallstrtuplistdiv"
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                fontWeight: "normal",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  maxWidth: "240px",
                                  textAlign: "right",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-all",
                                }}
                              >
                                {item.name}
                              </div>{" "}
                            </div>
                            <div
                              className="d-flex justify-content-end newuserTooltip newiconnext2"
                              style={{
                                cursor: "pointer",
                                position: "absolute",
                                right: "0px",
                                // bottom: "0px",
                                padding: "12px",
                              }}
                              onClick={() => {
                                setIndexCounter(item.id);
                                redirectProfile(item.dippNumber);
                              }}
                            >
                              <img src={profile} height={40} width={40} />

                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "23px",
                                  top: "59px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          style={{ position: "relative", minWidth: "13rem" }}
                          className="menidallstrtuplisttd"
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                alignItems: "center",
                                display: "flex",
                                maxWidth: "240px",
                              }}
                            >
                              {item.name}
                            </div>{" "}
                            <div
                              className="d-flex justify-content-end newuserTooltip newiconnext"
                              style={{
                                cursor: "pointer",
                                position: "absolute",
                                right: "0px",
                                bottom: "0px",
                                padding: "12px",
                              }}
                              onClick={() => {
                                setIndexCounter(item.id);
                                redirectProfile(item.dippNumber);
                              }}
                            >
                              <img src={profile} height={40} width={40} />

                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "23px",
                                  top: "59px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            className="newuserTooltip dippallsrtuplistadmndash"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "100px",
                            }}
                          >
                            <a
                              onClick={() => {
                                ViewApplication(item.dippNumber);
                                setIndexCounter(item.id);
                              }}
                              className="color-green"
                            >
                              {item.dippNumber}
                            </a>
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={{ left: "60px", top: "75px" }}
                            >
                              View Application
                            </span>
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "100px",
                            }}
                            className="dippallsrtuplistadmndash"
                          >
                            {item.city}
                          </div>
                        </td>

                        <td>
                          <div
                            style={{
                              // display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="mntrshipstdstrtuplist"
                          >
                            {item.activeMentorships > 0 ? (
                              <>
                                <div> {item.activeMentorships}</div>
                                <div
                                  className="d-flex justify-content-end newuserTooltip messageiconallstrtuplistadmindash"
                                  style={{
                                    cursor: "pointer",
                                    // alignItems: "end",
                                    justifyContent: "center",
                                    height: "100px",
                                    // width: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={mentorshipIcon}
                                    alt={item.title}
                                    onClick={() => {
                                      setIndexCounter(item.id);
                                      props.setStartUpIdList(item.id);
                                      window.open(
                                        `/startup-dashboard/mentorships/${item?.id}`,
                                        "_blank"
                                      );
                                      let reRoute = window;
                                      reRoute.fromModule = "AdminModule";
                                    }}
                                    width="40px"
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      top: "104px",
                                      left: "20px",
                                      width: "10vw",
                                    }}
                                  >
                                    View Mentorships
                                  </span>
                                </div>
                              </>
                            ) : (
                              <div style={{ paddingTop: "30px" }}>
                                {item.activeMentorships}
                              </div>
                            )}
                          </div>
                        </td>
                        {item?.phone?.substr(0, 2) == "91" ? (
                          <td className="phoneNumberTable">
                            <div
                              style={{
                                // display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              className="mntrshipstdstrtuplist"
                            >
                              <div
                                style={{
                                  display: "flex",

                                  justifyContent: "left",
                                  alignItems: "center",
                                  wordBreak: "break-all",
                                  whiteSpace: "pre-wrap",
                                  width: "75%",
                                }}
                              >
                                +91 {item.phone.substr(2, item.phone.length)}
                                <br />
                                {item.email}
                              </div>
                              {!PRODUCTION_MOVE_HIDDEN && 
                              <div
                                className="d-flex justify-content-end newuserTooltip messageiconallstrtuplistadmindash"
                                style={{
                                  cursor: "pointer",
                                  // alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  // width: "40px",
                                  display: "flex",
                                }}
                              >
                                <img
                                  src={buttonSendMessage}
                                  onClick={() => {
                                    setChatBoxModalOpen(true);
                                    setMentorRequest(item);
                                    setMentorRequestId(item.id);
                                  }}
                                  width="40px"
                                />
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    top: "102px",
                                    left: "20px",
                                    width: "115px",
                                  }}
                                >
                                  Send Message
                                </span>
                              </div>
}
                            </div>
                          </td>
                        ) : (
                          <td>
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",

                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                {item.phone}
                                <br /> {item.email}
                              </div>
                              {!PRODUCTION_MOVE_HIDDEN && 
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  width: "40px",
                                  display: "flex",
                                }}
                              >
                                <img
                                  src={buttonSendMessage}
                                  onClick={() => {
                                    setChatBoxModalOpen(true);
                                    setMentorRequest(item);
                                    setMentorRequestId(item.id);
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    top: "102px",
                                    left: "20px",
                                    width: "115px",
                                  }}
                                >
                                  Send Message
                                </span>
                              </div>
}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {(startUpList !== undefined && startUpList.length) > 0 ? (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={startUpListPagineate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  ) : (
                    ""
                  )}
                </div>

                <ChatBoxModal
                  modalVisibility={chatBoxModalOpen}
                  setModalVisibility={setChatBoxModalOpen}
                  receiverInfo={mentorRequest}
                  receiverId={mentorRequestId}
                />
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpList: state.StartUpReducer.AllStartUpList.data,
    startUpListPagineate: state.StartUpReducer.AllStartUpList.paginate,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getStartupList,
  getNamesList,
  getPredefineOptionsList,
  getStepperTooltipData,
  destructNamesList,
})(withRouter(AllStartUpList));
